// this file is generated by update_shopify_store_data.py at 2026-11-03 20:11:45.937076
var courses = [
    {
        "course_id": "8EC410C0-15C7-F011-99A1-005056A730AF",
        "course_version": 2,
        "name": "Springer Publishing - Adult CCRN\u00ae Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Adult Critical Care Registered Nurse (CCRN\u00ae) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nCCRN\u00ae is a registered trademark of the American Association of Critical-Care Nurses (AACN). The AACN does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and clinical knowledge areas aligned with the current Adult CCRN&reg; exam blueprint.</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to analyze patient scenarios across major body systems.</li>\r\n    <li>Demonstrate readiness for the Adult CCRN&reg; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<li>Introduction</li>\r\n<li>Module 1: Certification Exam</li>\r\n<li>Module 2: Cardiovascular System Review</li>\r\n<li>Module 3: Respiratory System Review</li>\r\n<li>Module 4: Endocrine System Review</li>\r\n<li>Module 5: Hematology and Immunology Review</li>\r\n<li>Module 6: Gastrointestinal System Review</li>\r\n<li>Module 7: Renal and Genitourinary Review</li>\r\n<li>Module 8: Integumentary System Review</li>\r\n<li>Module 9: Musculoskeletal System Review</li>\r\n<li>Module 10: Neurological System Review</li>\r\n<li>Module 11: Behavioral and Psychosocial Review</li>\r\n<li>Module 12: Multisystem Review</li>\r\n<li>Module 13: Professional Caring and Ethical Practice</li>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3C4352CA-6E88-11DB-BFA9-000423AF2167",
                "course_category_name": "Disorders and Conditions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Procedures",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Critical Care Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];